const isMobile = () => {
  if (typeof window !== 'undefined' && window.matchMedia) {
    return window.matchMedia('(max-width: 768px)').matches;
  }
  return false;
};
export default isMobile;
